let navMenuDropdown = {
    menuTypes: {
        listCollapsed: 'NAV_MENU_DROPDOWN_LIST_COLLAPSED',
        listExpanded: 'NAV_MENU_DROPDOWN_LIST_EXPANDED',
        docked: 'FULL_MENU',
    },
    toggleMethods: {
        header: 'NAV_MENU_DROPDOWN_HEADER',
        listCloseInteraction: 'NAV_MENU_DROPDOWN_LIST_CLOSE_INTERACTION',
        dock: 'MENU_BUTTON',
    },
};

module.exports = {
    navMenuDropdown,
};
